import BannerEnum from '../enumerators/banner.enum'

export default class BannerVideoComponent {
    constructor() {
        BannerVideoComponent.init()
    }

    static init() {
        const videoElmt = document.createElement('video')
        const videoSrc = document.createElement('source')

        videoSrc.type = $(BannerEnum.VIDEO).data('banner-video-type')
        videoSrc.src = $(BannerEnum.VIDEO).data('banner-video-src')
        videoElmt.muted = true
        videoElmt.loop = true

        videoElmt.appendChild(videoSrc)
        $(BannerEnum.VIDEO).append(videoElmt)
        videoElmt.play()
    }
}
